import { render, staticRenderFns } from "./resourceLibrary.vue?vue&type=template&id=39982ad3"
import script from "./resourceLibrary.vue?vue&type=script&lang=js"
export * from "./resourceLibrary.vue?vue&type=script&lang=js"
import style0 from "./resourceLibrary.vue?vue&type=style&index=0&id=39982ad3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports